<template>
  <WapPopup v-model:show="visible" teleport="body">
    <dl>
      <dt
        v-for="shareIcon in shareList"
        :key="shareIcon.value"
        @click="onShare(shareIcon.value)"
      >
        <img :src="shareIcon.img" alt="">
        <span>{{ $t(shareIcon.value) }}</span>
      </dt>
    </dl>
  </WapPopup>
</template>
<script setup>
  import { getCurrentInstance, reactive, ref, watch } from 'vue'
  import { storeToRefs } from 'pinia'
  import { useSystemStore } from '@/stores/system'
  import { copyText } from '@/utils'
  import { useRoute } from 'vue-router';
  import copylink from '@/assets/photo/wap/copylink.png'
  import facebook from '@/assets/photo/wap/facebook.png'
  import twitter from '@/assets/photo/wap/twitter.png'

  const { proxy } = getCurrentInstance()
  const route = useRoute()

  const emit = defineEmits(['update:modelValue'])
  const props = defineProps({
    modelValue: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    info: {
      type: Object,
      default: () => {}
    },
    bindUrl: {
      type: String,
      default: ''
    },
    myOppoShareData: {
      type: Object,
      default: () => {}
    }
  })

  const systemStore = useSystemStore()
  const { isApp, isMyOppo } = storeToRefs(systemStore)

  const visible = ref(false)

  const shareList = import.meta.env.VITE_COUNTRY === 'CHINA' ? ref([{
    value: 'copylink',
    img: copylink
  }]) : ref([{
    value: 'facebook',
    img: facebook
  }, {
    value: 'twitter',
    img: twitter
  }, {
    value: 'copylink',
    img: copylink
  }])


  // let customTitle = 'Win prizes by sharing #OnePlusThrough9 with the world @oneplus'

  // 点击分享
  const onShare = (type) => {
    let addCustomText = route.name.includes('thread') && route.params.id === '1205346106855653385'

    proxy.$ga('share', {
      "screen_name": route.name,
      "item_id": `${props.info?.type === 1 ? 'Article' : (props.info?.type === 2 ? 'Moment' : 'Poll')} + ${route.params.id}`,
      "content_type": route.name === 'thread' ? 'Thread' : 'Product',
      "button_name": type || 'Copy Link',
      "circleId": props.info?.circleBasicInfo?.id,
      "author_id": props.info?.publishUserInfo?.uid
    })
    let url = ''
    switch (type) {
      case 'facebook':
        url = `http://www.facebook.com/sharer.php?u=${encodeURIComponent(props.bindUrl ? props.bindUrl : location.href)}}`
        break
      case 'twitter':
        // url = `https://twitter.com/intent/tweet?url=${encodeURIComponent(props.bindUrl ? props.bindUrl : location.href)}${addCustomText ? `&text=${encodeURIComponent(customTitle)}` : ''}`
        url = `https://twitter.com/intent/tweet?url=${encodeURIComponent(props.bindUrl ? props.bindUrl : location.href)}`
        break
      default:
        copyText(`${props.bindUrl ? props.bindUrl : location.href} ${props.title}`).then(() => {
          proxy.$toast({
            message: proxy.$t('inviter.copyToast'),
            duration: 1500,
          })
        })
    }
    if (type === 'facebook' || type === 'twitter') {
      window.open(url, "_blank", "toolbar=yes, location=yes,  directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, width=600, height=450,top=100,left=350");
    }
    visible.value = false
  }


  watch(() => props.modelValue, async (val) => {
    if (val) {
      console.log(props.myOppoShareData)

      if (isApp.value) {
        let params = {
          link: props.bindUrl ? props.bindUrl : location.href,
          title: props.title
        }
        if (isMyOppo.value) {
          const { data } = await proxy.$getClientContext()
          if (data.packagename === 'com.oplus.member') {
            params = data.appVersion < 84200 ? params : props.myOppoShareData
          } else {
            params = data.appVersion < 91100 ? params : props.myOppoShareData
          }
        }
        // let shareTitle = addCustomText ? customTitle : props.title
        proxy.$share(params)
        emit('update:modelValue', false)
        return
      }
    }
    visible.value = val
  })

  watch(visible, (val) => {
    if (val) {
   
    } else {
      emit('update:modelValue', val)
    }
  })
</script>
<style lang="postcss" scoped>
dl {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  padding: 26px 12px 0;
  height: 140px;
  box-sizing: border-box;
  dt {
    display: flex;
    flex-flow: column wrap;
    align-items: center;
    justify-content: center;
    width: 84px;
    height: 90px;
    img {
      width: 40px;
      height: 40px;
      margin-bottom: 6px;
    }
    span {
      font-size: 10px;
      color: var(--text-secondary);
    }
  }
}
</style>